import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {MealsComponent} from '../../meals/meals.component';
import {MealViewModel} from '../../../../shared/viewModels/meal.viewModel';
import {NouisliderComponent} from 'ng2-nouislider';
import {Constants} from '../../../../shared/config/constants.config';
import {AddRecipeModalComponent} from '../add-recipe/add-recipe.component';
import {ProductsService} from '../../../../shared/services/products.service';
import {RecipeAttributeOptionViewModel, RecipeAttributeViewModel} from '../../../../shared/viewModels/recipeAttribute.viewModel';
import {GlobalCategoryViewModel} from '../../viewModels/category.viewModel';

@Component({
    selector: 'app-add-recipe-filter-modal',
    templateUrl: './add-recipe-filter.component.html',
    styleUrls: ['./add-recipe-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddRecipeFilterModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    @ViewChild('slider') slider: NouisliderComponent;

    tooltipSliderConfig = null;

    mealsComponent: MealsComponent;
    meal: MealViewModel;
    attributes: RecipeAttributeViewModel[];
    mealCalories = 100;
    addRecipeComponent: AddRecipeModalComponent;
    selectedOptions = {};
    selectedGlobalCategories = [];

    hasVideo = false;
    mealPrepFriendly = null;

    globalCategories: GlobalCategoryViewModel[] = [];

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly productsService: ProductsService,
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {
        this.productsService.getGlobalCategories().subscribe(globalCategories => {
            this.globalCategories = globalCategories;
            this.changeDetectorRef.markForCheck();
        });

        this.productsService.getRecipesAttributes().subscribe(attributes => {
            this.attributes = attributes;
            this.changeDetectorRef.markForCheck();
        });

        const interval = setInterval(() => {
            if (this.addRecipeComponent) {
                clearInterval(interval);

                this.tooltipSliderConfig = {
                    // connect: true,
                    tooltips: true,
                    start: this.addRecipeComponent.left_calories,
                    range: {
                        min: 1,
                        max: this.addRecipeComponent.left_calories
                    },
                    // snap: true,
                    pips: {
                        mode: 'range',
                        density: 5
                    },
                    step: 1,
                    format: {
                        to: function (value) {
                            return Number(value).toFixed(0) + ' kcal';
                        },
                        from: function (value) {
                            return Number(value.replace(' kcal', '')).toFixed(0);
                        }
                    }
                };
                this.mealCalories = this.addRecipeComponent.left_calories;
                this.changeDetectorRef.markForCheck();
            }
        });
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    onFilter() {
        this.updateAddRecipeComponent();
        this.addRecipeComponent.attributeOptionsChange(Object.values(this.selectedOptions));
        this.addRecipeComponent.hasVideo = this.hasVideo;
        this.addRecipeComponent.selectedGlobalCategories = this.selectedGlobalCategories;
        this.addRecipeComponent.mealPrepFriendly = this.mealPrepFriendly;
        this.bsModalRef.hide();
        this.addRecipeComponent.initRecipes();
    }

    markAttrOption(attr_id: number, option: RecipeAttributeOptionViewModel) {
        this.selectedOptions[attr_id] = option.id + '';
        this.changeDetectorRef.markForCheck();
    }

    changeHasVideo() {
        this.hasVideo = !this.hasVideo;
        this.changeDetectorRef.markForCheck();
    }

    changeMealPrepFriendly() {
        this.mealPrepFriendly = !this.mealPrepFriendly;
        this.changeDetectorRef.markForCheck();
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    private updateAddRecipeComponent() {
        this.addRecipeComponent.leftCaloriesChanged(this.mealCalories);
    }

    checkCategory(categoryId: number) {
        const newArr = [];
        let have = false;

        // tslint:disable-next-line:forin
        for (const selectedCategoryIdIndex in this.selectedGlobalCategories) {
            const id = this.selectedGlobalCategories[selectedCategoryIdIndex];

            // tslint:disable-next-line:radix
            if (parseInt(id) === categoryId) {
                have = true;
            } else {
                newArr.push(id + '');
            }
        }

        if (have === false) {
            newArr.push(categoryId + '');
        }

        this.selectedGlobalCategories = newArr;
        this.changeDetectorRef.markForCheck();
    }
}
